import Reveal from "@/components/motion/Reveal";

const STEPS = [
    {
        n: "01",
        title: "Crea tu tienda",
        body: "Regístrate, ponle nombre a tu tienda y sube tu logo. En minutos tienes una vitrina con tu propia dirección web.",
    },
    {
        n: "02",
        title: "Sube tus productos",
        body: "Fotos, precios, variantes e inventario. Tú decides qué vendes y a qué precio, sin límite de productos.",
    },
    {
        n: "03",
        title: "Cobra y envía",
        body: "Recibe pagos con tarjeta y genera la guía de envío desde el mismo panel. Nosotros negociamos las tarifas por ti.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="como-funciona"
            data-testid="home-how-it-works"
            className="py-20 sm:py-28 lg:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
                        Cómo funciona
                    </p>
                    <h2 className="mt-4 text-4xl sm:text-5xl lg:text-[3.5rem] font-extrabold tracking-[-0.03em] leading-[1.02] text-[#1A1A1A] text-balance">
                        Empieza a vender en tres pasos
                    </h2>
                    <p className="mt-5 text-lg text-[#4A4A4A] leading-relaxed">
                        Sin código, sin diseñadores y sin contratos. Si sabes
                        publicar una foto en redes, sabes usar Tiendify.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-3 gap-10 lg:gap-14">
                    {STEPS.map((step, i) => (
                        <div key={step.n} data-testid={`step-${i + 1}`}>
                            {/* La regla se traza: el paso se "abre" antes de leerse */}
                            <Reveal variant="draw" delay={i * 0.12}>
                                <div className="h-0.5 bg-[#1A1A1A]" />
                            </Reveal>
                            <Reveal delay={i * 0.12 + 0.15} className="pt-6">
                                <span className="text-sm font-bold tabular-nums text-primary">
                                    {step.n}
                                </span>
                                <h3 className="mt-3 text-2xl font-bold tracking-[-0.02em] text-[#1A1A1A]">
                                    {step.title}
                                </h3>
                                <p className="mt-3 text-base text-[#4A4A4A] leading-relaxed">
                                    {step.body}
                                </p>
                            </Reveal>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
